// Chart configuration
export const CHART_CONFIG = {
  margin: { top: 50, bottom: 68, left: 60, right: 32 },
  height: 312,
  desiredTickCount: 6, // Desired number of ticks on the Y-axis
  badgePadding: 7,
  containerBorderRadius: 6,
  xAxisStrokeWidth: 1,
  marker: {
    verticalLineStrokeWidth: 3,
    pointRadius: 4,
    pointStrokeWidth: 3,
  },
} as const;
